import Divider from "@material-ui/core/Divider";
import {
  Box,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";
import axios from "axios";
import { ModalError, ModalWarning, PrimaryButton } from "components";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";
import CARIS from "../../../assets/img/newCarisLogo.webp";

function ManageComposer() {
  const history = useHistory();
  const message = useSelector(state => state.auth.message);
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [optionComposer, setOptionComposer] = useState([]);
  const [selectedComposer, setSelectedComposer] = useState(null);
  const [urlRedirect, setUrlRedirect] = useState("");
  const handleSelect = () => {
    ModalWarning(
      `Are you sure you want to continue as ${selectedComposer?.composer_name} ?`,
      "Select Composer/Author"
    ).then(res => res?.isConfirmed && submitSelect());
  };

  const getDetail = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/me`, {
        headers,
      });
      setUrlRedirect(res?.data?.data?.user_menu?.[0]?.children?.[0]?.page_url);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };
  const getOptionComposer = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/composer-manager/composers`, {
        headers,
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        selected: false,
      }));
      setOptionComposer(modifiedData);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };
  const submitSelect = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.put(
        `${hardBaseUrl}/composer-manager/set-composer/${selectedComposer?.composer_id}`,
        {},
        { headers }
      );
      localStorage.setItem("token", res?.data?.data?.access_token);
      localStorage.setItem("composer_id", selectedComposer?.composer_id);
      history.push(urlRedirect);
      history.go(0);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };
  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [getOptionComposer(), getDetail()];

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (message !== null) {
      window.location.reload();
    }
  }, [message]);

  return (
    <Box display="flex" justifyContent="center" mt="95px">
      <Box>
        <Box display="grid" justifyContent="center">
          <img src={CARIS} alt="" width="206px" />
          {loadingPage ? (
            <Skeleton variant="rounded" height="200px" width="500px" />
          ) : (
            <Box
              border="1px solid #ebebeb"
              borderRadius="5px"
              mt="32px"
              minWidth="500px"
            >
              <Typography fontWeight={700} m={2}>
                Select Composer/Author
              </Typography>
              <Divider />
              <List>
                {optionComposer?.map(item => (
                  <ListItemButton
                    key={item?.composer_id}
                    onClick={() => setSelectedComposer(item)}
                    selected={
                      item?.composer_id === selectedComposer?.composer_id
                    }
                  >
                    <ListItemText primary={`${item.composer_name}`} />
                  </ListItemButton>
                ))}
              </List>
              <Divider />
              <Grid container justifyContent="right" p={2}>
                <PrimaryButton
                  label="Select"
                  onClick={handleSelect}
                  disabled={!selectedComposer}
                />
              </Grid>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
export default ManageComposer;
